<template>
  <div>
    <b-input-group v-for="(objective, index) in value" :key="index" :prepend="(index + 1).toString()" class="mb-2" size="sm">
      <b-form-input v-model.trim="value[index]" :disabled="!editMode" />
      <b-input-group-append v-if="editMode">
        <b-button variant="outline-danger" @click="deleteObjective(index)">ลบ</b-button>
      </b-input-group-append>
    </b-input-group>

    <b-button v-if="editMode" size="sm" variant="primary" @click="addObjective"><font-awesome-icon icon="plus-circle" />เพิ่มวัตถุประสงค์</b-button>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array, required: true },
    editMode: { type: Boolean, required: false, default: true }
  },
  methods: {
    addObjective () {
      this.value.push('')
    },
    deleteObjective (index) {
      this.$delete(this.value, index)
    }
  }
}
</script>
